function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "c",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "d",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "f",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "g",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "h",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "j",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "k",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "l",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "m",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "n",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}), React.createElement("path", {
  id: "p",
  d: "M61.5.2C95.5.2 123 27.9 123 62c0 34.2-27.5 61.9-61.5 61.9S.1 96.2.1 62A61.6 61.6 0 0161.5.2z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 -1)"
}, React.createElement("path", {
  fill: "#F4E6A3",
  d: "M123 62.5c0 34-27.3 61.5-61 61.5S1 96.5 1 62.5 28.3 1 62 1s61 27.5 61 61.5"
}), React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  fill: "#FDFAEF",
  d: "M61.5 62z",
  mask: "url(#b)"
}), React.createElement("mask", {
  id: "e",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#d"
})), React.createElement("path", {
  fill: "#FDFAEF",
  d: "M61.5 62z",
  mask: "url(#e)"
}), React.createElement("mask", {
  id: "i",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#h"
})), React.createElement("path", {
  fill: "#FDFAEF",
  d: "M61.5 62z",
  mask: "url(#i)"
}), React.createElement("mask", {
  id: "o",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#n"
})), React.createElement("path", {
  fill: "#FDFAEF",
  d: "M61.5 62z",
  mask: "url(#o)"
}), React.createElement("mask", {
  id: "q",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#p"
})), React.createElement("path", {
  fill: "#FDFAEF",
  d: "M61.5 62zm0 0zm0 0zm0 0zm0 0zm0 0zm0 0L81 148.8h28.8L61.5 62zm0 0l99.8 86.8h23.4v-17.5L61.5 62zm0 0l123.2 33.4V75.2L61.5 62zm0 0l123.2-13.7V28L61.5 62zm0 0L184.7-8.3v-16.5H160L61.5 62zm0 0l47.3-86.8H80.1L61.5 62zm0 0L42-24.8H13.2L61.5 62zm0 0l-99.8-86.8h-23.4v17.5L61.5 62zm0 0L-61.7 28.7v20.2L61.5 62zm0 0L-61.7 75.8V96L61.5 62zm0 0l-123.2 70.3v16.5h24.9L61.5 62zm0 0l-47.3 86.8H43L61.5 62z",
  mask: "url(#q)"
}), React.createElement("path", {
  fill: "#FBC56D",
  d: "M97 62.5a35.5 35.5 0 11-71 0 35.5 35.5 0 0171 0"
}));

var SvgUv = function SvgUv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 123 123",
    width: 100,
    height: 100,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/uv.5d80440a.svg";
export { ForwardRef as ReactComponent };